// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const ProductChangeRequestStateValues = [
	"INITIAL",
	"IN_PRE_EVALUATION",
	"IN_REQUIREMENT_SPECIFICATION",
	"TRANSFERRED_TO_DESIGN",
	"SHELVED",
	"CANCELLED",
] as const;

export type ProductChangeRequestState = (typeof ProductChangeRequestStateValues)[number];

export const getProductChangeRequestStateLabels = () => ({
	INITIAL: t("initial"),
	IN_PRE_EVALUATION: t("in_pre_evaluation"),
	IN_REQUIREMENT_SPECIFICATION: t("in_requirement_specification"),
	TRANSFERRED_TO_DESIGN: t("transferred_to_design"),
	SHELVED: t("shelved"),
	CANCELLED: t("cancelled"),
});

export const getProductChangeRequestStateLabel = (value: ProductChangeRequestState): string => {
	return getProductChangeRequestStateLabels()[value];
};
